export default (options = {}, target = 'container') => ({
  macy: null,
  defaultOptions: {},

  init() {
    if (typeof Macy !== 'function') {
      throw new Error('Macy library is missing')
    }
    this.$nextTick(() => {
      this.macy = Macy({
        container: this.$el,
        trueOrder: false,
        waitForImages: false,
        margin: 0,
        breakAt: {
          520: 2,
          400: 1
        },
        ...options
      })
    })
  }
})
